import { render, staticRenderFns } from "./AgronomySamplesTable.vue?vue&type=template&id=b8ea0b36"
import script from "./AgronomySamplesTable.vue?vue&type=script&lang=js"
export * from "./AgronomySamplesTable.vue?vue&type=script&lang=js"
import style0 from "./AgronomySamplesTable.vue?vue&type=style&index=0&id=b8ea0b36&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports